import { Button } from "antd";
import { DownloadOutlined } from '@ant-design/icons';
import DownloadFile from './../../../utils/DownloadFile';
import config from "./../../../config";

const DescargarArchivo = ({ label, size, path, nameFile }) => {

    return (
        <>
            <Button type="primary" shape="round" icon={<DownloadOutlined />} size={size}
            onClick={() => DownloadFile(`${config.server}/${path}`, nameFile)}>
                { label }
            </Button>
        </>
    )
}

export default DescargarArchivo;